module.exports = __webpack_public_path__ + "img/cffb802b43f7a598a8f718d5da92bdf6.cffb802b.png";